(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/constant"), require("@splat/theme"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , , ], factory);
	else if(typeof exports === 'object')
		exports["button"] = factory(require("@splat/constant"), require("@splat/theme"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else
		root["button"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE__splat_theme__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__) {
return /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buttonContainerClassName": function() { return /* binding */ buttonContainerClassName; },
/* harmony export */   "buttonContainerBlockClassName": function() { return /* binding */ buttonContainerBlockClassName; },
/* harmony export */   "errorButtonContainerClassName": function() { return /* binding */ errorButtonContainerClassName; },
/* harmony export */   "successButtonContainerClassName": function() { return /* binding */ successButtonContainerClassName; },
/* harmony export */   "primaryButtonContainerClassName": function() { return /* binding */ primaryButtonContainerClassName; },
/* harmony export */   "normalButtonContainerClassName": function() { return /* binding */ normalButtonContainerClassName; },
/* harmony export */   "warningButtonContainerClassName": function() { return /* binding */ warningButtonContainerClassName; },
/* harmony export */   "buttonDisabledContainerClassName": function() { return /* binding */ buttonDisabledContainerClassName; },
/* harmony export */   "normalButtonDisabledContainerClassName": function() { return /* binding */ normalButtonDisabledContainerClassName; },
/* harmony export */   "successButtonDisabledContainerClassName": function() { return /* binding */ successButtonDisabledContainerClassName; },
/* harmony export */   "errorButtonDisabledContainerClassName": function() { return /* binding */ errorButtonDisabledContainerClassName; },
/* harmony export */   "warningButtonDisabledContainerClassName": function() { return /* binding */ warningButtonDisabledContainerClassName; },
/* harmony export */   "primaryButtonDisabledContainerClassName": function() { return /* binding */ primaryButtonDisabledContainerClassName; },
/* harmony export */   "smallButtonContainerClassName": function() { return /* binding */ smallButtonContainerClassName; },
/* harmony export */   "buttonLoadingIconClassName": function() { return /* binding */ buttonLoadingIconClassName; }
/* harmony export */ });
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_3__);




var buttonContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)(csstips__WEBPACK_IMPORTED_MODULE_1__.inlineBlock, (0,csstips__WEBPACK_IMPORTED_MODULE_1__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonSizes.topBottomPadding), (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonSizes.leftRightPadding)), {
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonSizes.raduisSize),
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonSizes.commonFontSize),
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonSizes.lineHeight),
  border: 'none',
  outline: 'none',
  cursor: 'pointer',
  textDecoration: 'none',
  $nest: {
    '& + &': {
      marginLeft: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonSizes.nestCollision)
    }
  }
});
var buttonContainerBlockClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)(csstips__WEBPACK_IMPORTED_MODULE_1__.block, {
  width: (0,csx__WEBPACK_IMPORTED_MODULE_2__.percent)(100)
});
var errorButtonContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.errorBackground.toString(),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.errorFont.toString(),
  $nest: {
    '&:hover': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.errorHighlightBackground.toString()
    },
    '&:active': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.errorActiveBackground.toString()
    }
  }
});
var successButtonContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.successBackground.toString(),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.successFont.toString(),
  $nest: {
    '&:hover': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.successHighlightBackground.toString()
    },
    '&:active': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.successActiveBackground.toString()
    }
  }
});
var primaryButtonContainerClassName = function primaryButtonContainerClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
    background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.themePrimaryBackground(theme).toString(),
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.primaryFont.toString(),
    $nest: {
      '&:hover': {
        background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.themePrimaryHoverBackground(theme).toString()
      },
      '&:active': {
        background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.themePrimaryActiveBackground(theme).toString()
      }
    }
  });
};
var normalButtonContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.normalBackground.toString(),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.normalFont.toString(),
  $nest: {
    '&:hover': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.normalHighlightBackground.toString()
    },
    '&:active': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.normalActiveBackground.toString()
    }
  }
});
var warningButtonContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.warningBackground.toString(),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.warningFont.toString(),
  $nest: {
    '&:hover': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.warningHighlightBackground.toString()
    },
    '&:active': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.warningActiveBackground.toString()
    }
  }
});
var buttonDisabledContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  opacity: 0.5,
  cursor: 'not-allowed'
});
var normalButtonDisabledContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.normalBackground.toString()),
  $nest: {
    '&:hover': {
      background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.normalBackground.toString())
    },
    '&:active': {
      background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.normalBackground.toString())
    }
  }
});
var successButtonDisabledContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.successBackground.toString()),
  $nest: {
    '&:hover': {
      background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.successBackground.toString())
    },
    '&:active': {
      background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.successBackground.toString())
    }
  }
});
var errorButtonDisabledContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.errorBackground.toString()),
  $nest: {
    '&:hover': {
      background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.errorBackground.toString())
    },
    '&:active': {
      background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.errorBackground.toString())
    }
  }
});
var warningButtonDisabledContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.warningBackground.toString()),
  $nest: {
    '&:hover': {
      background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.warningBackground.toString())
    },
    '&:active': {
      background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.warningBackground.toString())
    }
  }
});
var primaryButtonDisabledContainerClassName = function primaryButtonDisabledContainerClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
    background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.themePrimaryBackground(theme).toString()),
    $nest: {
      '&:hover': {
        background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.themePrimaryBackground(theme).toString())
      },
      '&:active': {
        background: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonColors.themePrimaryBackground(theme).toString())
      }
    }
  });
};
var smallButtonContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_1__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonSizes.lightTopBottomPadding), (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonSizes.lightLeftRightPadding)), {
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.ButtonSizes.fontSize)
});
var buttonLoadingIconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(6)
});

/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/theme":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/theme","commonjs2":"@splat/theme"} ***!
  \***********************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_theme__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Type": function() { return /* binding */ Type; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var buttonClass = function buttonClass(type) {
  return (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('button', type);
};

var disabledButtonClass = function disabledButtonClass(type) {
  return (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('disabled-button', type);
};

var Type;

(function (Type) {
  Type["primary"] = "primary";
  Type["error"] = "error";
  Type["warning"] = "warning";
  Type["success"] = "success";
})(Type || (Type = {}));

var Button = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(Button, _tsx$Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabled", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "to", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "blank", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "type", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "small", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "isSubmit", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "block", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "loading", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(Button, [{
    key: "onClick",
    value: function onClick() {}
  }, {
    key: "buttonClassName",
    get: function get() {
      switch (this.type) {
        case Type.error:
          return (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.errorButtonContainerClassName, buttonClass(Type.error));

        case Type.primary:
          return (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.primaryButtonContainerClassName(this.theme), buttonClass(Type.primary));

        case Type.success:
          return (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.successButtonContainerClassName, buttonClass(Type.success));

        case Type.warning:
          return (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.warningButtonContainerClassName, buttonClass(Type.warning));

        default:
          return (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.normalButtonContainerClassName, buttonClass('default'));
      }
    }
  }, {
    key: "buttonDisabledClassName",
    get: function get() {
      switch (this.type) {
        case Type.error:
          return (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.errorButtonDisabledContainerClassName, disabledButtonClass(Type.error));

        case Type.primary:
          return (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.primaryButtonDisabledContainerClassName(this.theme), disabledButtonClass(Type.primary));

        case Type.success:
          return (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.successButtonDisabledContainerClassName, disabledButtonClass(Type.success));

        case Type.warning:
          return (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.warningButtonDisabledContainerClassName, disabledButtonClass(Type.warning));

        default:
          return (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.normalButtonDisabledContainerClassName, disabledButtonClass('default'));
      }
    }
  }, {
    key: "disabledClassName",
    get: function get() {
      return (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.buttonDisabledContainerClassName, this.buttonDisabledClassName);
    }
  }, {
    key: "renderRouterLink",
    value: function renderRouterLink() {
      var h = this.$createElement;
      var buttonClassName = this.buttonClassName,
          small = this.small,
          block = this.block,
          loading = this.loading,
          disabled = this.disabled,
          onClick = this.onClick,
          to = this.to,
          blank = this.blank,
          disabledClassName = this.disabledClassName;
      var disabledRoute = loading || disabled;
      var routeStyles = (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.buttonContainerClassName, buttonClassName, block && _style__WEBPACK_IMPORTED_MODULE_10__.buttonContainerBlockClassName, disabledRoute && disabledClassName, small && _style__WEBPACK_IMPORTED_MODULE_10__.smallButtonContainerClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('button'));
      var slotEl = this.$slots.default ? h("span", [this.$slots.default]) : null;
      return (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(to) === 'object' ? h("router-link", {
        "attrs": {
          "to": to,
          "disabled": disabledRoute
        },
        "class": routeStyles,
        "on": {
          "click": onClick
        }
      }, [slotEl]) : h("a", {
        "attrs": {
          "href": to,
          "target": blank ? '_blank' : '_self',
          "disabled": disabledRoute
        },
        "class": routeStyles,
        "on": {
          "click": onClick
        }
      }, [slotEl]);
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var buttonClassName = this.buttonClassName,
          small = this.small,
          block = this.block,
          loading = this.loading,
          disabled = this.disabled,
          onClick = this.onClick,
          isSubmit = this.isSubmit,
          to = this.to,
          renderRouterLink = this.renderRouterLink,
          disabledClassName = this.disabledClassName;
      return to ? renderRouterLink() : h("button", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.buttonContainerClassName, buttonClassName, block && _style__WEBPACK_IMPORTED_MODULE_10__.buttonContainerBlockClassName, (loading || disabled) && disabledClassName, small && _style__WEBPACK_IMPORTED_MODULE_10__.smallButtonContainerClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('button')),
        "attrs": {
          "type": isSubmit ? 'submit' : 'button',
          "disabled": disabled || loading
        },
        "on": {
          "click": onClick
        }
      }, [loading ? h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)('el-icon-loading', _style__WEBPACK_IMPORTED_MODULE_10__.buttonLoadingIconClassName)
      }) : null, this.$slots.default ? h("span", [this.$slots.default]) : null]);
    }
  }]);

  return Button;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Button.prototype, "disabled", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Button.prototype, "to", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Button.prototype, "blank", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Button.prototype, "type", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Button.prototype, "small", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Button.prototype, "isSubmit", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Button.prototype, "block", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Button.prototype, "loading", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Emit)('click')], Button.prototype, "onClick", null);

Button = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_9___default())]
})], Button);
/* harmony default export */ __webpack_exports__["default"] = (Button);
}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map